// extracted by mini-css-extract-plugin
module.exports = {"readme":"Readme_readme__KJvaO","previewButton":"Readme_previewButton__2Mz_Q","preview":"Readme_preview__1Rz7C"};